module.exports = __webpack_public_path__ + "static/media/user-login-screen.e27c8735.png";